import SessionTimeoutPageTitle from './SessionTimeoutPageTitle';

export default SessionTimeoutPageTitle;
